import { Box, Button, Grid, Typography } from '@material-ui/core'
import React, { Fragment } from 'react'
import moment from 'moment'
import Link from 'next/link'
import i18n from 'i18next'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Paper from '@material-ui/core/Paper'
import { useFetch } from '../context/useFetch'

export const MyApplications = () => (
  <Fragment>
    <Typography variant="h2" component="h1">
      {i18n.t('profile.candidat.applications.title')}
    </Typography>
    <Grid className="profileSection">
      <List />
    </Grid>
  </Fragment>
)

const List = () => useFetch(
  ({ fetch }) => ({
    applications: fetch('profile/applications')
  }),
  ({ applications }) => (
    <Grid container spacing={2}>
      {applications.data.length != 0 ? (
        <TableContainer component={Paper}>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>{i18n.t('profile.candidat.applications.table.offer')}</TableCell>
                <TableCell align="right">{i18n.t('profile.candidat.applications.table.company')}</TableCell>
                <TableCell align="right">{i18n.t('profile.candidat.applications.table.date')}</TableCell>
                <TableCell align="right">{i18n.t('profile.candidat.applications.table.examinated')}</TableCell>
                <TableCell align="right">{i18n.t('profile.candidat.applications.table.rejected')}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {applications.data.map((row, i) => (
                <TableRow key={row.id}>
                  <TableCell component="th" scope="row">
                    <Link href={`/job-offer/${applications.included.job_offers[row.job_offer_id].hashid}/apply`}>
                      <a>{applications.included.job_offers[row.job_offer_id].label}</a>
                    </Link>
                  </TableCell>
                  <TableCell align="right">{applications.included.companies[applications.included.job_offers[row.job_offer_id].company.id].name}</TableCell>
                  <TableCell align="right">{moment(row.created_at).format('DD MMMM YYYY')}</TableCell>
                  <TableCell align="right">{row.is_application_seen && '✅'}</TableCell>
                  <TableCell align="right">{Boolean(row.rejection_notification_sent_at) && '💔'}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <EmptySlate />
      )}
    </Grid>
  )
)

const EmptySlate = () => (
  <Box my={15}>
    <Grid container justifyContent="center" spacing={2}>
      <img style={{ width: '50%' }} src="/empty_slate_candidature.jpeg" />
      <Grid item xs={12}>
        <Typography variant="h2" align="center">
          {i18n.t('profile.candidat.applications.empty.des1')}
        </Typography>
        <Typography variant="h4" align="center">
          {i18n.t('profile.candidat.applications.empty.des2')}
        </Typography>
      </Grid>
      <Link href="/">
        <Button id="myApplications-apply" variant="contained" color="primary">
          {i18n.t('job_offer.job_apply.apply')}
        </Button>
      </Link>
    </Grid>
  </Box>
)